import React, { useEffect, useState } from 'react'
import QuickCraftBlocks from './QuickCraftBlocks';
import QuickCraftRarityCalculator from './QuickCraftRarityCalculator';

const QuickCraftStart = ({ name, data, choosedOptions, selectHandler, closeWindow, handleCraftButton }) => {
  const [isUFVisible, setIsUFVisible] = useState(false);
  const isDisabled = () => {
    return choosedOptions.some((obj) =>
      Object.keys(obj).some((key) => key !== "label" && !obj[key])
    );
  };

  useEffect(() => {
  const observer = new MutationObserver(() => {
    const element = document.querySelector('.uf-visible');
    setIsUFVisible(!!element);
  });

  observer.observe(document.body, { childList: true, subtree: true });

  return () => observer.disconnect();
}, []);

  return (
    <>
      <h2 className="modal-window__title">Quick Craft Identity: {name}</h2>
      <p className="modal-window__additional">
        Choose collection and rarity to craft '{name}' Identity
      </p>
      <QuickCraftBlocks data={data} selectHandler={selectHandler} choosedOptions={choosedOptions} />
      <footer className="modal-window__footer">
        <QuickCraftRarityCalculator choosedOptions={choosedOptions} />
        <button
          className="modal-window__footer-close"
          type="button"
          onClick={closeWindow}
          disabled={isUFVisible}
        >
          Cancel
        </button>
        <button
          className="modal-window__footer-submit"
          type="button"
          disabled={isDisabled()}
          onClick={handleCraftButton}
        >
          Craft
        </button>
      </footer>
    </>
  );
}

export default QuickCraftStart;
